export const DEFAULT_POLLING_INTERVAL = 3000;

export const CACHE_TIME = 5 * 60 * 1000; // 5 min

export const NO_DATA_FOUND_RESPONSE = 'no_heatmap_data';

export const INVALID_SEARCH_RESPONSE = 'invalid_search';

export const SCREENSHOT_DATA_QUERY_KEY = 'screenshot_data';

export const TAKE_SCREENSHOT_DATA_QUERY_KEY = 'take_screenshot_data';

export const HEAT_DATA_QUERY_KEY = 'heat_data';

export const ENGAGEMENT_DATA_QUERY_KEY = 'engagement_data';
